import {
  StyledSessionDetailsDrawerBookingDetailsItem,
  StyledSessionDetailsDrawerBookingDetailsWrapper,
} from "./style";

type SessionDetailsDrawerBookingDetailsProps = {
  data: {
    title: string;
    value: string;
  }[];
};

export function SessionDetailsDrawerBookingDetails({
  data,
}: SessionDetailsDrawerBookingDetailsProps) {
  return (
    <StyledSessionDetailsDrawerBookingDetailsWrapper>
      {data.map((b) => (
        <StyledSessionDetailsDrawerBookingDetailsItem key={b.title}>
          <p className="item-title">{b.title}</p>
          <p className="item-value">{b.value}</p>
        </StyledSessionDetailsDrawerBookingDetailsItem>
      ))}
    </StyledSessionDetailsDrawerBookingDetailsWrapper>
  );
}
